import Component from "../abstracts/Component";
import ScrollMagic from 'scrollmagic';
// import 'debug.addIndicators';

export default class FittingStickyComponent extends Component {
  get SELECTORS() {
    return {
      main: '.c-fitting-information-module',
      anchors: '.sticky-fittings a'
    }
  }

  get CLASSES() {
    return {
      activeAnchor: 'active'
    }
  }

  constructor() {
    super();

    this.controller = null;
    this.anchors = $(this.SELECTORS.anchors);
  }

  bindEvent(i, el) {


    // al click sull'ancora scrolltop
    $(this.anchors[i]).click(e => {
      e.preventDefault();

      let elementScroll = document.querySelector(e.currentTarget.getAttribute('href'));
      let headerHeight = this.$matchMedia(null, 'lg') ? 80 : this.$matchMedia('lg', 'sm') ? 71 : 57;
      // console.log(e.currentTarget.getAttribute('href'));
      $("html, body").animate({ scrollTop: document.documentElement.scrollTop + elementScroll.getBoundingClientRect().y - headerHeight - this.anchors.parent().height()}, "slow");
    });

    console.log('altezza: ', el.offsetHeight);

    new ScrollMagic.Scene({
        triggerElement: el,
        duration: el.offsetHeight
      })
      .setClassToggle(this.anchors[i], this.CLASSES.activeAnchor)
      // .addIndicators()
      .addTo(this.controller);

  }

  render() {

    if(document.body.classList.contains('editMode')) return;

    var elements = $(this.SELECTORS.main);

    if (elements.length > 0) {

      this.controller = new ScrollMagic.Controller();

      setTimeout(()=>{
        elements.each((index, element) => {
          this.bindEvent(index, element);
        });
      }, 500);
    }
  }
}
